import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Gikam from '../../../core/gikam-core.js';
import Vue from 'vue';
import Base from '../../base';
var defaultOptions = {
  id: void 0,
  src: [],
  number: 0
};

var ImageViewer = /*#__PURE__*/function (_Base) {
  _inherits(ImageViewer, _Base);

  var _super = _createSuper(ImageViewer);

  function ImageViewer(props) {
    var _this;

    _classCallCheck(this, ImageViewer);

    _this = _super.call(this, props);
    _this.listeners = {
      rendered: Gikam.emptyFunction,
      clickNext: Gikam.emptyFunction,
      clickPrev: Gikam.emptyFunction
    };

    _this.initialize(props, defaultOptions).init(props);

    return _this;
  }

  _createClass(ImageViewer, [{
    key: "createModel",
    value: function createModel() {
      var h = this.$createElement;
      var options = this.options;
      this.model = new Vue({
        el: Gikam.createDom('div', this.options.renderTo),
        components: {
          imageViewer: function imageViewer() {
            return import('../vue/imageViewer.vue');
          }
        },
        provide: {
          imageViewer: this
        },
        data: function data() {
          return {
            options: options
          };
        },
        render: function render() {
          var h = arguments[0];
          return h("imageViewer", {
            "attrs": {
              "options": this.options
            }
          });
        }
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.createModel();
    }
  }, {
    key: "refresh",
    value: function refresh(src) {
      this.options.src = src;
    }
  }]);

  return ImageViewer;
}(Base);

export { ImageViewer as default };